export enum SelectedChartTypeEnum{
    default,
    combo,
    zones
}